import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=6e831273&"
import script from "./ViewData.vue?vue&type=script&lang=js&"
export * from "./ViewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports